import { render } from "./GoogleEmailPage.vue?vue&type=template&id=0c643ab2&scoped=true"
import script from "./GoogleEmailPage.vue?vue&type=script&lang=js"
export * from "./GoogleEmailPage.vue?vue&type=script&lang=js"

import "./GoogleEmailPage.vue?vue&type=style&index=0&id=0c643ab2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c643ab2"]])

export default __exports__